import { AUFDialogComponent } from './../../dialogs/AUFDialog/AUFDialog.component';
import { NbToastrService, NbDialogModule, NbDialogService } from '@nebular/theme';
import { AssocUtilisateurFermeService } from './../../../../services/assocutilisateurferme.service';
import { FermeService } from './../../../../services/ferme.service';
import { Role } from './../../../../models/role.model';
import { TabService } from './../../../../services/tab.service';
import { TranslateService } from '@ngx-translate/core';
import { OnInit, Component, Input, ViewChild } from '@angular/core';
import { Utilisateur } from './../../../../models/utilisateur.model';
import { UtilisateurService } from './../../../../services/utilisateur.service';
import { LocalDataSource } from 'ng2-smart-table';
import { environment } from '../../../../../environments/environment.prod';
import { Ferme } from '../../../../models/ferme.model';
import { ButtonRenderComponent } from './test.component';

@Component({
  selector: 'app-tabUtilisateur',
  templateUrl: './tabUtilisateur.component.html',
  styleUrls: ['./tabUtilisateur.component.scss'],
})
export class TabUtilisateurComponent implements OnInit {

  @Input() utilisateurs: Utilisateur[];
  @ViewChild('form') myForm;
  testString: string;
  defaultOrdre: number;
  source: LocalDataSource;
  selectedFerme: Ferme;
  fermes: Ferme[];
  isEdited: boolean;
  constructor(private tabService: TabService,
              private utilisateurService: UtilisateurService,
              private translate: TranslateService,
              private fermeService: FermeService,
              private dialogService: NbDialogService,
              private auf: AssocUtilisateurFermeService,
              private toastrService: NbToastrService) {
    this.selectedFerme = fermeService.selectedFerme;
    this.fermes = this.fermeService.grantedFermes;
    this.isEdited = false;
  }
  ngOnInit() {
    console.log(this.myForm);
    this.myForm.delete.subscribe((data,b,c,d) => {
      console.log('DELETEMEC');
      console.log(data);
      console.log(b);
      console.log(c);
      console.log(d);
      // this.myForm.grid.edit(data);
      this.myForm.grid.getNewRow();
      console.log(this.myForm.grid.getRows());
      console.log(this.myForm.grid.getSelectedRows());
      console.log(this.myForm.grid.getFirstRow());
    });
    // onSelectRowSource
   /* myGrid = new Grid;
    this.myForm.grid.onSelectRowSource.subscribe((data,b,c,d) => {
      console.log('onSelectRowSource');
      console.log(data);
      console.log(b);
      console.log(c);
      console.log(d);
    });*/

/*
// Permet d'appliquer une classe css (déclenché en boucle pour chaque ligne)
this.settings['rowClassFunction'] = (row) => {
 console.log('RVT');
 console.log(row);
            }; */
  }

  userRowSelect(instance){
    console.log('RVTRVT');
    console.log(instance);
    console.log(this.myForm.grid.getSelectedRows());
    }
    rowSelect(instance){
      console.log('SELECT');
      console.log(instance);
      console.log(this.myForm.grid.getSelectedRows());
      }

  settings = {
     mode: 'external',
     actions: {
          custom: [
            {
              name: 'edit',
              title: '<i class="nb-edit" title="edit"></i>'
            },
            {
              name: 'delete',
              title: '<i class="nb-trash" title="delete"></i>'
            },
          ],
          add:true,
          edit:false,
          delete:true
        },
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },/*
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
        mode: 'inline',
      },*/
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: false,
      },
    columns: {
      nom: {
        title: this.translate.instant('NAME'),
        type: 'custom',
        renderComponent: ButtonRenderComponent,
      },
      'email': {
        title: this.translate.instant('EMAIL'),
        type: 'string',
        editable: false,
        valuePrepareFunction: (cell, row) => {
          console.log(row);
          console.log(row.id);
        },
      },
      'password': {
        title: this.translate.instant('PASSWORD'),
        type: 'string',
        filter: false,
        valuePrepareFunction: (value) => {
          value = '';
          return value;
        },
      },
      'role': {
        title: this.translate.instant('ROLE'),
        type: 'number',
        valuePrepareFunction: (value) => {
          value = this.translate.instant('ROLE_' + value.id);
          return value;
        },
        compareFunction:(direction: any, a: any, b: any) => {
          a = a.id;
          b = b.id;
          return this.tabService.compareFunction(direction, a, b);
        },
        filterFunction: (value: any, search: string) => {
          value = this.translate.instant(value.id).toUpperCase();
          return this.tabService.filterFunction(value, search);
        },
        editor: {
          type: 'list',
          config: {
            list: [
              {value: 1, title: this.translate.instant('ADMIN')},
              {value: 2, title: this.translate.instant('CHIEF-OPERATOR')},
              {value: 3, title: this.translate.instant('OPERATOR')},
            ],
          },
        },
      },
    },
  };

  onDeleteConfirm(event): void {
    if (window.confirm(this.translate.instant('USER_DELETE_CONFIRM'))) {
      this.utilisateurService.delete_utilisateur(event.data.id)
      .subscribe(response => {
        event.confirm.resolve();
      },
      (err) => {
        err.error.forEach(error => {
          this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
          this.translate.instant('ERROR'));
        });
      });
    } else {
      event.confirm.reject();
    }
  }

  onEditConfirm(event): void {
    switch(event.newData.role) {
      case '1': {
        event.newData.role = new Role(1, 'Admin');
        break;
      }
      case '2': {
        event.newData.role = new Role(2, 'Chef Opérateur');
        break;
      }
      case '3': {
        event.newData.role = new Role(3, 'Opérateur');
        break;
      }
   }
    if (window.confirm(this.translate.instant('USER_EDIT_CONFIRM'))) {
      this.utilisateurService.update_utilisateur(event.newData)
      .subscribe(response => {
        event.newData.password = response.password;
        event.confirm.resolve(event.newData);
      },
      (err) => {
        err.error.forEach(error => {
          this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
          this.translate.instant('ERROR'));
        });
      });
    } else {
      event.confirm.reject();
    }
  }

  onCreateConfirm(event): void{
    switch(event.newData.role) {
      case '1': {
        event.newData.role = new Role(1, 'Admin');
        break;
      }
      case '2': {
        event.newData.role = new Role(2, 'Chef Opérateur');
        break;
      }
      case '3': {
        event.newData.role = new Role(3, 'Opérateur');
        break;
      }
   }
    if (window.confirm(this.translate.instant('USER_ADD_CONFIRM'))) {
      this.utilisateurService.create_utilisateur(event.newData)
      .subscribe(response => {
        event.newData = response;
        event.confirm.resolve(event.newData);
        this.auf.create_auf(event.newData.id).subscribe(response => {
          this.toastrService.success(this.translate.instant('USER_ADDED'),
          this.translate.instant('SUCCESS'));
        });
      },
      (err) => {
        err.error.forEach(error => {
          this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
          this.translate.instant('ERROR'));
        });
      });
    } else {
      event.confirm.reject();
    }
  }

  open(event) {
    this.dialogService.open(AUFDialogComponent, {
      context: {
        selectedUser: event.data,
      },
    });
  }
}
